import * as React from 'react';
export const dokuSvg = React.forwardRef(function dokuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#D52E2F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.23 4.016H4.574c-.459 0-.568.102-.575.547V6c0 .417.11.52.513.527l3.332.047c.609.014 1.218 0 1.82.014.793.014 1.498.28 2.134.766 1.45 1.122 1.574 3.332.35 4.639a3.478 3.478 0 0 1-2.6 1.122c-1.656.014-3.312 0-4.967-.007-.473 0-.575.11-.575.582v1.436c.007.438.137.561.575.561 1.505 0 3.003.007 4.508 0 .404 0 .807-.027 1.211-.075a5.413 5.413 0 0 0 3.701-2.005 5.728 5.728 0 0 0 .855-6.061c-.95-2.32-2.832-3.441-5.315-3.537-.767-.02-1.54 0-2.313.007Zm14.756-.007C25.304 4.009 28 6.622 28 9.852c0 3.229-2.696 5.842-6.02 5.842-3.326 0-6.014-2.613-6.014-5.836 0-3.222 2.688-5.85 6.02-5.85Zm0 9.352c1.861 0 3.373-1.573 3.373-3.51 0-1.936-1.512-3.502-3.38-3.502-1.86 0-3.38 1.573-3.38 3.503 0 1.942 1.52 3.51 3.387 3.51ZM6.805 21.195c-.11-.137-.075-.294-.075-.438v-3.975c-.028-.26-.123-.363-.363-.417a1.19 1.19 0 0 0-.267-.035H4.547c-.417.007-.547.137-.547.548v10.584c0 .403.11.52.513.526h1.478c.643 0 .732-.075.732-.745v-2.36c0-.267.055-.5.253-.692.274-.28.547-.56.835-.828.219-.205.376-.191.574.048.185.226.356.459.534.691l2.668 3.496c.185.24.424.39.74.39l2.277-.006c.123 0 .26.013.336-.192-.055-.096-.124-.233-.213-.349l-3.188-4.098-1.293-1.683c-.212-.28-.205-.438.041-.698.035-.04.069-.075.103-.11l2.32-2.298 1.771-1.758c.096-.103.26-.178.192-.39-.055-.014-.11-.041-.171-.048-.753-.014-1.492-.028-2.244-.028-.431 0-.787.172-1.095.493-1.32 1.382-2.661 2.737-4.002 4.098-.096.11-.171.253-.356.274Zm9.175-1.54v1.102c.02.76-.048 1.512.075 2.264a5.874 5.874 0 0 0 6.198 4.96 5.883 5.883 0 0 0 5.713-5.917c.02-1.697 0-3.387 0-5.084v-.225c-.028-.253-.13-.383-.383-.39a40.594 40.594 0 0 0-1.82 0c-.253.013-.356.137-.37.39v.383c-.02 1.71-.027 3.414-.054 5.124a3.49 3.49 0 0 1-.712 2.039 3.292 3.292 0 0 1-4.597.67 3.59 3.59 0 0 1-1.437-2.955c-.014-1.697.014-3.387.027-5.083 0-.473-.11-.575-.581-.582h-1.512c-.452.007-.548.11-.548.575v2.73Z',
      fill: '#fff',
    }),
  );
});
dokuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var doku = {
  category: 'brand',
  colorable: false,
  name: 'doku',
  svg: dokuSvg,
};
